// extracted by mini-css-extract-plugin
export default {"showExampleLink":"ShowExamplePhoto_showExampleLink__oitpO"};